module.exports = __webpack_public_path__ + "static/media/globe.1d7ac05c.svg";